import { Scanner } from "@yudiel/react-qr-scanner";
import { Localization } from "../components/Localization";
import { useTranslation } from "react-i18next";

export function CodeScanner () {
  const { t } = useTranslation();

  const handleScan = (result) => {
    if (result && result.length > 0) {
      window.location.href = result[0].rawValue;
    }
  };

  const previewStyle = {
    height: 320,
    width: 320,
  }

  return (
    <div className="scanner-wrapper">
      <div className="scanner-container">
        <div className="scanner-hint">{ t('ScanQrCode') }</div>
        <Scanner onScan={ handleScan } scanDelay={ 500 } style={previewStyle} />
        <Localization />
      </div>
    </div>
  );
}
